import React from 'react';
import ActionButtons from './ActionButtons'; 

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const DetailItem = ({ label, value }) => {
  const isEmpty = !value || (Array.isArray(value) && value.length === 0);
  if (isEmpty) return null;

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = `${API_BASE}/uploads/cv/${value}`;
    link.download = value;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="detailSection">
      <h3 className="detailHeading">{label}</h3>
      {label === 'Document' && typeof value === 'string' ? (
        <ActionButtons
          isEditing={false}
          onDownload={handleDownload}
          showEdit={false}
          showDelete={false}
          showView={false}
          showDownload={true}
        />
      ) : (
        <p className="detailValue">{value}</p>
      )}
    </section>
  );
};

export default DetailItem;
